import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/management/edit.svg'
import _imports_2 from '@/assets/img/management/settings.svg'


const _hoisted_1 = {
  key: 0,
  class: "fullModal genericPadding bgWhite fullHeightModal hasHeader"
}
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "fs_12 greyBlue" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_6 = { class: "fs_14 spaceCadet" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "communityTitle" }
const _hoisted_9 = { class: "subscribersCount" }
const _hoisted_10 = { class: "communityContainer mt-4" }
const _hoisted_11 = { class: "d-flex justify-content-between" }
const _hoisted_12 = { class: "fs_13 greyBlue text-uppercase" }
const _hoisted_13 = { class: "fs_14 spaceCadet mt-2 pr-3" }
const _hoisted_14 = { class: "checkbox-wrapper-14" }
const _hoisted_15 = { class: "fs_13 greyBlue text-uppercase" }
const _hoisted_16 = {
  key: 0,
  class: "listButtonContainer my-4"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  class: "me-2",
  src: _imports_1
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  class: "me-2",
  src: _imports_2
}, null, -1)
const _hoisted_20 = { class: "d-flex align-items-center justify-content-between mt-3" }
const _hoisted_21 = { class: "fs_13 greyBlue text-uppercase" }
const _hoisted_22 = { class: "reteContainer mt-2" }
const _hoisted_23 = { class: "reteImage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_ctx.loaded)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "sideContainer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
          }, [
            _hoisted_3
          ]),
          _createVNode("span", _hoisted_4, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_impostazionigruppo",
              text: "Impostazioni gruppo",
              class: "text_uppercase"
            })
          ]),
          _hoisted_5
        ]),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_localized_text, {
                class: "fs_13 greyBlue text-uppercase",
                localizedKey: "app_titolo",
                text: "Titolo"
              }),
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.chatRoomVm.name), 1)
            ]),
            _createVNode("div", null, [
              _createVNode(_component_localized_text, {
                class: "fs_13 greyBlue text-uppercase",
                localizedKey: "app_iscritti",
                text: "iscritti"
              }),
              _createVNode("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.chatRoomVm.participants.length) + " ", 1),
                _createVNode(_component_localized_text, {
                  localizedKey: "app_iscritti",
                  text: "iscritti"
                })
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_descrizione",
                  text: "Descrizione",
                  class: "text_uppercase"
                })
              ]),
              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.chatRoomVm.description), 1)
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_notifiche",
                  text: "Notifiche",
                  class: "text_uppercase"
                })
              ]),
              _withDirectives(_createVNode("input", {
                type: "checkbox",
                class: "switch mt-2 mb-2",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.chatRoomVm.isSubscribed = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.chatRoomVm.isSubscribed]
              ])
            ])
          ]),
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("div", {
                  class: "listButton genericShadow fs_14 spaceCadet",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openEditModal && _ctx.openEditModal(...args)))
                }, [
                  _hoisted_17,
                  _createVNode(_component_localized_text, {
                    localizedKey: "app_descrizioneeimmagini",
                    text: "Descrizione e immagini"
                  })
                ]),
                _hoisted_18,
                _createVNode("div", {
                  class: "listButton genericShadow fs_14 spaceCadet",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openSettingsModal && _ctx.openSettingsModal(...args)))
                }, [
                  _hoisted_19,
                  _createVNode(_component_localized_text, {
                    localizedKey: "app_impostazioni",
                    text: "Impostazioni"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_partecipanti",
                text: "Partecipanti",
                class: "text_uppercase"
              })
            ]),
            _createVNode("div", {
              class: "fs_13 greyBlue text-uppercase pointer",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openPeopleModal && _ctx.openPeopleModal(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_veditutti",
                text: "Vedi tutti",
                class: "text_uppercase"
              })
            ])
          ]),
          _createVNode("div", _hoisted_22, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chatRoomVm.participants, (item, i) => {
              return (_openBlock(), _createBlock("div", {
                class: "reteItem",
                key: i,
                onClick: ($event: any) => (_ctx.openPerson(item))
              }, [
                _withDirectives(_createVNode("div", _hoisted_23, null, 512), [
                  [_directive_userimage, _ctx.$store.state.getUserImage(item.identifier)]
                ])
              ], 8, ["onClick"]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}